import Control, { ControlBase, ControlEvent } from "./control";
import DataSource, { DataSourceData } from "./datasource";
import { TypedEventEmitter, Disposable, TypedEventListener } from "./events";
import { NotifyPropertyChanged, NotifyPropertyChangedEvent, NotifyPropertyChangedEventFactory } from "./notify-property-changed";
import { NotifyPropertyChangingEvent } from "./notify-property-changing";
import { PropertySet } from "./propertyset";

import "./css/tagselector.css";
//const css = require("./css/tagSelector.css")

export interface TagSelectorOptions {
    dataValueField: string,
    dataTextField: string,
    /** Default: false */
    serverFiltering?: boolean,
    serverReadService?: string,
    minLengthFilter?: number,
    /** Default: false */
    liveFilter?: boolean,
    /** Default: false */
    readonly?: boolean
    maxItems?: number,
    minItems?: number,
    template?: string,
    dataSource?: DataSource,
    valueDelimiter?: string
}

export class TagSelector extends ControlBase implements Control {

    // private readonly _properties: PropertySet

    private elements!: {
        html: HTMLHtmlElement,
        main: HTMLDivElement,
        display: HTMLDivElement,
        displayValue: HTMLSpanElement,
        dropdownButton: HTMLButtonElement,
        dropdownContent: HTMLDivElement,
        searchContainer: HTMLElement,
        search: HTMLInputElement,
        popupCloseButton: HTMLButtonElement,
        selectedTagList: HTMLDivElement,
        messages: HTMLDivElement,
        availableTagList: HTMLUListElement
    }

    // private readonly _templates: {
    //     availableTag: AvailableTagTemplate,
    //     selectedTag: SelectedTagTemplate
    // }

    private readonly _disposableComponents: Disposable[] = []

    private readonly _availableItem: TagSelectorDataItemCollection
    private readonly _selectedItems: TagSelectorDataItemCollection

    private _beginUpdateCount: number = 0;
    // private propertySetStorer: Record<string, any>
    private _valueDelimiter: string

    // private _dataItemsMap = new WeakMap<HTMLElement, object | null>()

    constructor(private readonly options: TagSelectorOptions) {

        super()

        this.elements = {
            html: document.getElementsByTagName("html")[0] as HTMLHtmlElement,
            main: this.rootElement as HTMLDivElement,
            display: document.createElement("div"),
            displayValue: document.createElement("span"),
            dropdownButton: document.createElement("button"),
            dropdownContent: document.createElement("div"),
            searchContainer: document.createElement("div"),
            search: document.createElement("input"),
            popupCloseButton: document.createElement("button"),
            selectedTagList: document.createElement("div"),
            messages: document.createElement("div"),
            availableTagList: document.createElement("ul")
        }

        // selected tags template 
        const selectedTagTemplate = {
            create: (init: ElementTemplateCreateInit): HTMLElement => {
                const tagElement = document.createElement("div")
                const removeIcon = document.createElement("i")
                const removeButton = document.createElement("button")
                //const tag = document.createElement("div")
                const textContainer = document.createElement("span")

                removeIcon.className = "fa fa-times"
                removeButton.type = "button"
                removeButton.title = "Remover este item"
                removeButton.appendChild(removeIcon)
                removeButton.addEventListener("click", this.removeTagClick)

                textContainer.innerHTML = init.text || init?.dataBoundItem?.toString() || "empty"

                tagElement.className = "selected-tag"
                tagElement.appendChild(removeButton)
                tagElement.appendChild(textContainer)
                return tagElement
            }
        }
        this._selectedItems = new TagSelectorDataItemCollection(this.elements.selectedTagList, {
            template: selectedTagTemplate
        })

        // available tags template 
        const availableTagTemplate = {
            create: (init: ElementTemplateCreateInit): HTMLElement => {
                const tagElement = document.createElement("li")
                tagElement.innerHTML = init.text || init?.dataBoundItem?.toString() || "empty"
                tagElement.addEventListener("click", this.addTagClick)
                return tagElement
            }
        }
        this._availableItem = new TagSelectorDataItemCollection(this.elements.availableTagList, {
            template: availableTagTemplate
        })

        this.defineProperties({
            "readonly": { writable: true },
            "enabled": { writable: true },
            "visible": { writable: true },
            "value": { writable: true }
        })



        // const eventRegister = new EventRegister(this)
        // eventRegister.register("change", this.events.change);
        // eventRegister.register("tagselected");

        // this._properties = new PropertySet({
        //     readonly: options.readonly || false,
        //     visible: true,
        //     enabled: true
        // });

        // this._disposableComponents.push(
        //     this._properties.propertyChanging.on(this.onPropertyChanging),
        //     this._properties.propertyChanged.on(this.onPropertyChanged)
        // );

        // this._templates = {
        //     availableTag: new AvailableTagTemplate(this.formatDataItem),
        //     selectedTag: new SelectedTagTemplate()
        // }

        this._valueDelimiter = options.valueDelimiter || ","

        if (options.dataSource) {

            this._disposableComponents.push(options.dataSource.events.change.on(ev => this.loadData(ev.detail.data)));
            this.requestData();
        }
    }

    protected createRootElement(): HTMLElement {
        return document.createElement("div")
    }

    get enabled(): boolean {
        return this.getProperty("enabled");
    }

    set enabled(value: boolean) {
        this.setProperty("enabled", value)
    }

    get readonly(): boolean {
        return this.getProperty("readonly");
    }

    set readonly(value: boolean) {
        this.setProperty("readonly", this.readonly);
    }

    get visible(): boolean {
        return this.getProperty("visible");
    }

    set visible(value: boolean) {
        this.setProperty("visible", value)
    }

    get value(): string {
        return this.getProperty("value");
    }

    set value(value: string) {
        this.setProperty("value", value)
    }

    // readonly events = {
    //     change: new TypedEventEmitter<TagSelectorEventHandlersEventMap["change"]>()
    // }

    get items(): ReadonlyArray<TagSelectorDataItem> {
        return this._availableItem;
    }

    get selectedItems(): ReadonlyArray<TagSelectorDataItem> {
        return this._selectedItems;
    }

    render(parent: HTMLElement): void {

        if (this.elements?.main?.parentNode == parent)
            parent.removeChild(this.elements.main)

        // Create HTML elements
        this.elements.main.className = "tag-selector";
        this.elements.display.className = "display";
        this.elements.displayValue.className = "display-value";
        this.elements.dropdownButton.className = "dropbtn";
        this.elements.dropdownButton.title = "Clique aqui para selecionar os itens.";
        this.elements.dropdownContent.className = "tag-selector-popup";
        this.elements.searchContainer.className = "search-container";
        this.elements.search.type = "text";
        this.elements.search.placeholder = "Procurar...";
        this.elements.search.spellcheck = false;
        this.elements.search.autocomplete = "off";
        this.elements.search.className = "search";
        this.elements.popupCloseButton.className = "close-button"
        this.elements.popupCloseButton.type = "button"
        this.elements.selectedTagList.className = "selected-tag-collection";
        this.elements.messages.className = "messages";
        this.elements.search.addEventListener

        // Add element into DOM
        this.elements.display.appendChild(this.elements.displayValue);
        this.elements.display.appendChild(this.elements.dropdownButton);
        this.elements.searchContainer.appendChild(this.elements.search);
        this.elements.searchContainer.appendChild(this.elements.popupCloseButton);
        this.elements.dropdownContent.appendChild(this.elements.searchContainer);
        this.elements.dropdownContent.appendChild(this.elements.selectedTagList);
        this.elements.dropdownContent.appendChild(this.elements.messages);
        this.elements.dropdownContent.appendChild(this.elements.availableTagList);
        this.elements.main.appendChild(this.elements.display);
        this.elements.main.appendChild(this.elements.dropdownContent);

        // Add events listeners
        this.elements.dropdownButton.addEventListener("click", this.dropdownButtonClick);
        this.elements.dropdownButton.addEventListener("focus", this.dropdownButtonFocus);
        this.elements.dropdownButton.addEventListener("blur", this.dropdownButtonBlur);
        this.elements.popupCloseButton.addEventListener("click", this.closePopupButton);

        parent.appendChild(this.elements.main)
    }

    dipose() {
        this._disposableComponents.forEach(diposable => diposable?.dispose());
    }

    beginUpdate() {
        this._beginUpdateCount++;
    }

    resumeUpdate() {
        if (this._beginUpdateCount > 0) {
            this._beginUpdateCount--;

            if (this._beginUpdateCount === 0) {
                this.proccessLazyOperations()
            }
        }
    }

    // setProperty(name: string, value: any) {
    //     this._properties.set(name, value);
    // }
    // getProperty(name: string): any {
    //     throw new Error("Method not implemented.");
    // }

    protected onPropertyChanging(propertyName: string, newValue: any): boolean {
        // console.log(`Property "${ev.detail.propertyName}" changing to ${ev.detail.newValue}.`);

        switch (propertyName) {
            case "value":

                if (!this.validateNewValue(newValue))
                    return false

                break;
        }
        return true;
    }

    protected onPropertyChanged(property: string) {
        // console.log(`Property "${ev.detail.propertyName}" changed.`);

        switch (property) {
            case "value":
                const valueArray = this.valueToArray(this.value)

                this.beginUpdate()
                // this.items.forEach(item => {
                //     item.selected = valueArray.indexOf(item.value?.toString()) !== -1
                // })
                this.updateDisplayValue()
                this.resumeUpdate()

                break;
        }
    }



    private isUpdating(): boolean {
        return this._beginUpdateCount > 0;
    }

    private requestData() {
        if (this.options.serverReadService) {
            this.options.dataSource?.invoke(this.options.serverReadService)
        }
    }

    private formatDataItem = (dataItem: object | string | Function): string => {
        const display = (dataItem as Record<string, any>)[this.options.dataTextField];

        if (typeof display === "string") return display;
        else if (typeof display === "function") return display();
        else return dataItem.toString();
    }

    private isSelected(value: any): boolean {
        const strValue = this.valueToString(value)
        return this._selectedItems.find(item => this.valueToString(item.value) == strValue) !== undefined
        //return this.findItemByValue(value) !== undefined;
    }

    private findItemByValue(value: any): TagSelectorDataItem | undefined {
        const strValue = this.valueToString(value)
        return this._availableItem.find(item => this.valueToString(item.value) == strValue)
    }

    private valueToString(value: any): string {
        return value?.toString() || ""
    }

    private valueToArray(value: any): string[] {
        const str: string = (value?.toString() || "")
        return str.split(this._valueDelimiter)
    }

    private validateNewValue(value: any): boolean {
        return true
    }

    private updateValues(): void {

        const valueArray: string[] = []

        // this.items.filter(item => item.selected).forEach(dataItem => {
        //     valueArray.push(this.formatDataItem(dataItem.dataBoundItem || dataItem.text))
        // });

        //this.properties.set("value", valueArray.join(this.options.valueDelimiter))
        //this.propertySetStorer["value"] = valueArray.join(this.options.valueDelimiter)
        // this._properties.suspendEvents();
        // this._properties.set("value", null)
        // this._properties.resumeEvents();
    }

    private updateDisplayValue(): void {
        const textArray: string[] = []

        this._selectedItems.forEach(dataItem => {
            textArray.push(this.formatDataItem(dataItem.dataBoundItem || dataItem.text))
        });

        this.elements.displayValue.innerHTML = textArray.join(", ");
        this.elements.displayValue.title = textArray.join(", ");
    }

    /** Load data items. This methods is called always after datasource change */
    private loadData(data: DataSourceData): void {

        // const fragment = document.createDocumentFragment();
        // const template = new AvailableTagTemplate(dataItem => this.formatDataItem(dataItem))

        this.elements.availableTagList.innerHTML = ""

        // Keep only selected items
        //this._items = this._items.filter(item => item.selected)

        this._availableItem.clear()
        this._availableItem.beginUpdate()

        if (data && Array.isArray(data) && data.length > 0) {
            const dataItems = data as Record<string, any>[]
            dataItems.forEach(dataBoundItem => {

                const value = dataBoundItem[this.options.dataValueField]
                const text = dataBoundItem[this.options.dataTextField]?.toString()

                if (!this._selectedItems.findByValue(value)) {
                    this._availableItem.addNew(text, value, dataBoundItem)
                }
            });
        }
        this._availableItem.resumeUpdate()

        // if (!this.isUpdating())
        //     this.proccessLazyOperations()
    }

    // private createTagDataItem(element: HTMLElement, dataBoundItem: object): TagSelectorDataItem {
    //     const record = dataBoundItem as Record<string, any>
    //     const text = record[this.options.dataTextField]?.toString()
    //     const value = record[this.options.dataValueField]
    //     const listDataItem = TagSelectorDataItem.createNew(element, text, value, dataBoundItem)
    //     //listDataItem.propertyChanged.on(this.dataItemPropertyChanged)
    //     return listDataItem
    // }

    // private dataItemPropertyChanged = (args: NotifyPropertyChangedEvent) => {
    //     const dataItem = args.detail.sender as TagSelectorDataItem

    //     if (args.detail.propertyName === "selected") {
    //         if (dataItem.selected) {
    //             this.lazyOperations.push({ operation: "SELECT", dataItem: dataItem })
    //             if (!this.isUpdating()) this.proccessLazyOperations()
    //         }
    //         else {
    //             this.lazyOperations.push({ operation: "DESELECT", dataItem: dataItem })
    //             if (!this.isUpdating()) this.proccessLazyOperations()
    //         }
    //     }
    // }

    private lazyOperations: {
        operation: "ADD" | "REMOVE" | "SELECT" | "DESELECT",
        dataItem: TagSelectorDataItem
    }[] = []

    // private copyToChildrens(from: HTMLElement | DocumentFragment, to: HTMLElement | DocumentFragment) {
    //     for (let i = 0; i < from.children.length; i++) {
    //         to.appendChild(from.removeChild(from.children[i]));
    //     }
    // }

    private proccessLazyOperations() {
        let fragmentSelected: DocumentFragment | undefined
        let fragmentAvailable: DocumentFragment | undefined

        //const templateSelected = new SelectedTagTemplate(dataItem => this.formatDataItem(dataItem))
        //const templateAvailable = new AvailableTagTemplate(dataItem => this.formatDataItem(dataItem))

        let hadDeselect: boolean = false

        while (this.lazyOperations.length > 0) {
            const lazyOperation = this.lazyOperations[0]
            const dataItem = lazyOperation.dataItem

            if (lazyOperation.operation === "SELECT") {

                // // Remove from available list
                // dataItem.element?.parentNode?.removeChild(dataItem.element)
                // this._items.splice(this._items.indexOf(dataItem), 1)

                // if (!fragmentSelected) {
                //     fragmentSelected = document.createDocumentFragment()
                // }

                // // Create selected tag element
                // const selectedTagElement = document.createElement("div")
                // //const selectedTagDataItem = this.createTagDataItem(selectedTagElement, dataItem.dataBoundItem || { toString: () => dataItem.text })
                // this._templates.selectedTag.render(selectedTagElement, dataItem.dataBoundItem || { toString: () => dataItem.text }, this.removeTagClick)
                // // Set new element
                // dataItem.element = selectedTagElement

                // this._selectedItems.push(dataItem)
                // fragmentSelected.appendChild(selectedTagElement);
            }
            else if (lazyOperation.operation === "DESELECT") {

                // Remove from selected list
                dataItem.element?.parentNode?.removeChild(dataItem.element)
                this._selectedItems.splice(this._availableItem.indexOf(dataItem), 1)

                hadDeselect = true

                // if (!fragmentAvailable) {
                //     fragmentAvailable = document.createDocumentFragment()
                // }

                // const availableTagElement = document.createElement("li")
                // this.templates.availableTag.render(availableTagElement, dataItem.dataBoundItem || { toString: () => dataItem.text }, this.addTagClick)
                // // Set new element
                // dataItem.element = availableTagElement

                // fragmentAvailable.appendChild(availableTagElement)
            }
            else if (lazyOperation.operation === "ADD") {

                if (!fragmentAvailable) {
                    fragmentAvailable = document.createDocumentFragment()
                }
                fragmentAvailable.appendChild(dataItem.element)
                this._availableItem.push(dataItem);
            }
            // Remove
            this.lazyOperations.splice(0, 1)
        }

        if (fragmentSelected) {
            this.elements.selectedTagList.appendChild(fragmentSelected);
        }
        if (fragmentAvailable) {
            // if (this.options.serverFiltering) {
            //     this.requestData()
            // }
            // else {
            //     this.elements.availableTagList.appendChild(fragmentAvailable);
            // }
            this.elements.availableTagList.appendChild(fragmentAvailable);
        }

        if (fragmentSelected || hadDeselect) {
            this.updateValues();
        }

        if (hadDeselect) {
            this.doSearch()
            return;
        }
    }

    private doSearch(filter: string = this.elements.search.value) {
        if (filter !== "") {
            if (this.options.minLengthFilter && this.options.minLengthFilter > filter.length) {
                return;
            }
        }
        this.options.dataSource?.filter(this.options.dataTextField, filter)
    }

    private readonly htmlClick = (ev: Event): void => {
        if (!this.elements.main.contains(ev.target as Node)) {
            this.closePopup();
        }
    }

    private readonly searchKeyup = (ev: KeyboardEvent): void => {
        if (ev.key == "Escape" || ev.key == "Esc") {
            this.closePopup()
        }
        else if (this.options.liveFilter || ev.key === "Enter") {
            this.doSearch()
        }
    }

    private readonly dropdownButtonClick = (ev: Event) => {

        if (this.isPopupOpened()) {
            this.closePopup();
        } else {
            if (!this.options.serverFiltering) {
                const data = this.options.dataSource?.getData();
                if (data == null || data == undefined) {
                    this.requestData()
                }
            }
            this.openPopup();
        }
    }

    private readonly dropdownButtonFocus = (ev: Event) => {
        this.elements.main.classList.add("focused");
    }

    private readonly dropdownButtonBlur = (ev: Event) => {
        this.elements.main.classList.remove("focused");
    }

    private readonly closePopupButton = (ev: Event) => {
        ev.preventDefault()
        ev.stopPropagation()

        this.closePopup()
    }

    private readonly addTagClick = (ev: Event) => {
        // Necessário para o teste realizado no evento "click" do html
        ev.stopPropagation()

        let maxReached = false
        if (this.options.maxItems) {
            if (this.options.maxItems == 1) {
                maxReached = true;
                this._selectedItems.clear()
            }
            else if (this.options.maxItems === this._selectedItems.length + 1) {
                maxReached = true;
            }
            else if (this.options.maxItems === this._selectedItems.length) {
                this.setMessage(`Selecione no máximo ${this.options.maxItems} opções.`);
                return;
            }
        }


        const dataItem = this._availableItem.getByElement(ev.currentTarget as HTMLElement)

        if (!dataItem) {
            throw new Error(`No data associated with the element`)
        }

        this._availableItem.remove(dataItem)
        this._selectedItems.addNew(dataItem.text, dataItem.value, dataItem.dataBoundItem)



        // Dispatch event
        const tagSelectedEvent = TagSelectedEventFactory(dataItem.text, dataItem.value, dataItem.dataBoundItem || null)
        this.dispatchEvent(tagSelectedEvent)

        //tagElement.parentElement?.removeChild(tagElement);

        // Fire item selected event
        // Fire Change Event
        this.updateDisplayValue()
        this.elements.search.focus();

        if (maxReached) {
            this.closePopup()
        }
    }

    private selectItem(dataItem: TagSelectorDataItem): void {



        //const selectedTagDataItem = this.createTagDataItem()
    }

    private readonly removeTagClick = (ev: Event) => {
        ev.preventDefault()

        // Necessário para o teste realizado no evento "click" do html
        ev.stopPropagation();

        const tagElement = (ev.currentTarget as HTMLElement)?.closest(".selected-tag-collection > *") as HTMLElement
        const dataItem = this._selectedItems.getByElement(tagElement);

        if (!dataItem) {
            throw new Error(`No data associated with the element`)
        }

        // Register a lazy SELECT operation
        // this.lazyOperations.push({ operation: "DESELECT", dataItem: dataItem })
        // if (!this.isUpdating()) this.proccessLazyOperations()

        this._selectedItems.remove(dataItem);
        this.updateDisplayValue()
        this.doSearch()

        // // Dispatch event
        // const tagSelectedEvent = TagSelectedEventFactory(dataItem.text, dataItem.value, dataItem.dataBoundItem || null)
        // this.dispatchEvent(tagSelectedEvent)

        this.setMessage("")
        this.elements.search.focus();
    }

    // private selectItems(...dataItems: object[]): void {
    //     //const template = new SelectedTagTemplate(dataItem => this.formatDataItem(dataItem))

    //     dataItems.forEach(dataBoundItem => {

    //         const element = document.createElement("div")
    //         this.templates.selectedTag.render(element, dataBoundItem, this.removeTagClick)
    //         const dataItem = this.createTagDataItem(element, dataBoundItem)
    //         this.lazyOperations.push({ operation: "SELECT", dataItem })
    //     })

    //     if (!this.isUpdating())
    //         this.proccessLazyOperations()
    // }



    private isPopupOpened(): boolean {
        return this.elements.main.classList.contains("expanded")
    }

    private openPopup(): void {
        if (this.isPopupOpened()) return

        //const availableHeight = this.getViewPort().height - this.elements.main.getBoundingClientRect().bottom;

        this.elements.html.addEventListener("click", this.htmlClick);
        this.elements.search.addEventListener("keyup", this.searchKeyup);
        this.elements.main.classList.add("expanded")
        this.elements.dropdownContent.classList.add("expanded")
        this.elements.search.focus();

        if (!this.readonly) {
            this.doSearch()
        }
    }

    private closePopup(): void {
        if (!this.isPopupOpened()) return;

        this.elements.html.removeEventListener("click", this.htmlClick)
        this.elements.search.removeEventListener("keyup", this.searchKeyup)
        this.elements.main.classList.remove("expanded")
        this.elements.dropdownContent.classList.remove("expanded")
        this.elements.search.value = ""
        this.setMessage("")
    }

    private setMessage(message: string, type: "Error" = "Error"): void {
        this.elements.messages.innerHTML = message || ""
    }

    // addEventListener(type: string, listener: (event: ControlEvent) => void) {

    // }
}



export interface TagSelector {
    // onchange: (this: TagSelector, ev: TagSelectorEventHandlersEventMap["change"]) => any
    //ontagselected: (this: TagSelector, ev: TagSelectorEventHandlersEventMap["change"]) => any

    addEventListener<K extends keyof TagSelectorEventHandlersEventMap>(type: K, listener: (this: TagSelector, ev: TagSelectorEventHandlersEventMap[K]) => any, options?: boolean | AddEventListenerOptions): void;
    addEventListener(type: string, listener: EventListenerOrEventListenerObject, options?: boolean | AddEventListenerOptions): void;
    removeEventListener<K extends keyof TagSelectorEventHandlersEventMap>(type: K, listener: (this: TagSelector, ev: TagSelectorEventHandlersEventMap[K]) => any, options?: boolean | EventListenerOptions): void;
    removeEventListener(type: string, listener: EventListenerOrEventListenerObject, options?: boolean | EventListenerOptions): void;
}

function getViewPort() {
    var win = window,
        doc = document,
        docElem = doc.documentElement,
        body = doc.body,
        x = win.innerWidth || docElem.clientWidth || body.clientWidth,
        y = win.innerHeight || docElem.clientHeight || body.clientHeight;
    return { width: x, height: y };
}


// export interface TagSelector {

// }

interface TagSelectedEvent extends CustomEvent<{
    text: string
    value: any
    dataBoundItem: object | null
}> { }


interface TagSelectorEventHandlersEventMap {
    "change": Event,
    "TagSelected": TagSelectedEvent
}

const TagSelectedEventFactory =
    (text: string, value: any, dataBoundItem: object | null): TagSelectedEvent => new CustomEvent("TagSelected",
        {
            detail: { text, value, dataBoundItem }
        });



class AvailableTagTemplate {
    constructor(
        // private readonly container: HTMLElement | DocumentFragment,
        // private readonly dataMap: WeakMap<HTMLElement, object>,
        private readonly dataItemFormatter?: (dataItem: object) => string) {
    }

    render(tagElement: HTMLElement, dataItem: object, addClick: (ev: Event) => void): void {
        if (this.dataItemFormatter)
            tagElement.innerHTML = this.dataItemFormatter(dataItem)
        else
            tagElement.innerHTML = dataItem.toString()

        tagElement.addEventListener("click", addClick)

        // this.container.appendChild(li)
        // this.dataMap.set(li, dataItem)
    }
}

interface ElementTemplateCreateInit {
    dataBoundItem?: object,
    text?: string,
    dataTextField?: string,
    dataValueField?: string
}

interface SelectedTagTemplateRenderInit extends ElementTemplateCreateInit {
    removeClick: EventListener
}

interface ElementTemplate {
    create<T extends ElementTemplateCreateInit>(init: T): HTMLElement
}

interface SelectedTagTemplate {
    create(init: SelectedTagTemplateRenderInit): HTMLElement
}

class SelectedTagTemplate implements ElementTemplate {

    create(init: SelectedTagTemplateRenderInit): HTMLElement {
        const tagElement = document.createElement("div")
        const removeIcon = document.createElement("i")
        const removeButton = document.createElement("button")
        //const tag = document.createElement("div")
        const textContainer = document.createElement("span")

        removeIcon.className = "fa fa-times"
        removeButton.type = "button"
        removeButton.title = "Remover este item"
        removeButton.appendChild(removeIcon)
        removeButton.addEventListener("click", init.removeClick)

        if (init.dataBoundItem)
            textContainer.innerHTML = this.formatDataBoundItem(init.dataBoundItem)
        else
            textContainer.innerHTML = init.text || ""

        tagElement.className = "selected-tag"
        tagElement.appendChild(removeButton)
        tagElement.appendChild(textContainer)
        return tagElement
    }

    private formatDataBoundItem(dataBoundItem: Record<string, any>, dataTextField?: string) {
        if (dataTextField) {
            return dataBoundItem[dataTextField]?.toString()
        }
        else {
            return dataBoundItem?.toString()
        }
    }
}

interface ListDataItem {
    element: HTMLElement,
    text: string,
    value: any,
    dataBoundItem: object | undefined,
    format?(): string
}

interface TagSelectorDataItemCollectionInit {
    template?: ElementTemplate
}

class TagSelectorDataItemCollection extends Array<TagSelectorDataItem> {

    private readonly template: ElementTemplate
    private readonly dataMap = new WeakMap<HTMLElement, TagSelectorDataItem>()
    private updateCounter = 0;
    private clearPending = false
    private parentElementTemp: DocumentFragment | undefined

    constructor(private readonly parentElement: HTMLElement, init?: TagSelectorDataItemCollectionInit) {
        super()
        Object.setPrototypeOf(this, TagSelectorDataItemCollection.prototype)

        this.template = init?.template || {
            create: (init: ElementTemplateCreateInit): HTMLElement => {
                const element = document.createElement("div")
                element.innerHTML = init?.dataBoundItem?.toString() || init?.text || "empty"
                return element
            }
        };
    }

    get(index: number): TagSelectorDataItem | never {
        if (index < 0 || index > this.length - 1)
            throw new Error(`Index out of range: ${index}`)
        return this[index]
    }

    getByElement(element: HTMLElement): TagSelectorDataItem | never {
        if (!this.dataMap.has(element))
            throw new Error(`Element out of range.`)
        return this.dataMap.get(element)!
    }

    findByValue(value: any): TagSelectorDataItem | undefined {
        const valueStr = this.valueToString(value)
        return this.find(item => this.valueToString(item.value) == valueStr)
    }

    filterByText(text: string, options: { ignoreCase?: boolean } = { ignoreCase: true }): TagSelectorDataItem[] {
        if (options.ignoreCase === true)
            return this.filter(item => item.text?.toUpperCase() == text?.toUpperCase())
        else
            return this.filter(item => item.text == text)
    }

    toString(): string {
        return this.getValues().join(", ");
    }

    getValues(): string[] {
        const values: string[] = []
        this.forEach(item => values.push(this.valueToString(item.value)))
        return values
    }

    clear(): void {
        this.forEach(item => this.dataMap.delete(item.element))
        this.splice(0, this.length);

        if (this.isUpdating()) {
            if (this.parentElementTemp)
                this.parentElementTemp = document.createDocumentFragment()
            this.clearPending = true
        }
        else {
            this.parentElement.innerHTML = ""
        }
    }

    addNew(text: string, value: any, dataBoundItem: object | undefined = undefined): TagSelectorDataItem {
        const element = this.template.create({
            dataBoundItem: dataBoundItem,
            text: text,
            value: value
        })

        const dataItem = new TagSelectorDataItem(element, text, value, dataBoundItem)
        this.dataMap.set(element, dataItem)

        if (this.isUpdating()) {
            if (!this.parentElementTemp) {
                this.parentElementTemp = document.createDocumentFragment()
            }
            this.parentElementTemp.appendChild(element)
        }
        else {
            this.parentElement.appendChild(element)
        }

        this.push(dataItem);

        return dataItem
    }

    remove(item: TagSelectorDataItem): boolean {
        const index = this.indexOf(item)
        if (index !== -1) {
            item.element.parentNode?.removeChild(item.element)
            this.dataMap.delete(item.element)
            this.splice(index, 1)
        }
        return index !== -1;
    }

    removeAt(index: number): TagSelectorDataItem | undefined {
        if (index < 0 || index > this.length - 1)
            throw new Error(`Index out of range: ${index}`)

        const item = this.get(index)
        return this.remove(item) ? item : undefined
    }

    beginUpdate(): void {
        this.updateCounter++;
    }

    resumeUpdate(): void {
        if (this.updateCounter > 0) {
            this.updateCounter--

            if (this.updateCounter == 0) {
                if (this.clearPending) {
                    this.parentElement.innerHTML = ""
                    this.clearPending = false
                }
                if (this.parentElementTemp) {
                    this.parentElement.appendChild(this.parentElementTemp)
                    this.parentElementTemp = undefined
                }
            }
        }
    }

    private isUpdating(): boolean {
        return this.updateCounter > 0;
    }

    private valueToString(value: any): string {
        return value?.toString() || ""
    }
}

class TagSelectorDataItem implements ListDataItem {

    constructor(
        public readonly element: HTMLElement,
        public readonly text: string,
        public readonly value: any,
        public readonly dataBoundItem: object | undefined = undefined) {
    }

    format(): string {
        return this.toString()
    }

    // private notifyPropertyChanged(propertyName: string) {
    //     this.propertyChanged.emit(NotifyPropertyChangedEventFactory(this, propertyName))
    // }

    toString(): string {
        return this.text
    }
}